<template>
<div class="flex">
  <div class="row no-gutters row-bordered row-border-light">
    <div :style="{ display }" class="col-md-5 pt-0 px-2 py-3" >
      <button @click="close()" type="button" class=" btn btn-dark btn-sm " style="font-size: 10px; float: right; padding: 0px 6px;">
            &times;
      </button>
       
      <div  class="py-4" style="padding-bottom: 0rem!important;">
        <div class="border border-dark">
          <vue-highcharts  :options="optionsChartBar " ref="lineChartsBar" style="height: 67vh;" :redraw="true"> </vue-highcharts>
        </div>
      </div>
    </div>
  <div class="py-3 px-2" :class="col" style="padding-bottom: 0.5rem!important;">
    <div class="border border-dark">
      <div class="p-1" style="height:70vh; background-color: white"  >

      <l-map  :zoom="zoom" :center="center" style="" ref="myMap" >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-control > 
              <div class="d-flex flex-column">
                  <b-form-select  v-model="selectedCountry" class="mb-3" @change="ChangeCountry" style="background-color:#00948a!important; color:#fff;">
                  <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                    </template>

                    <!-- These options will appear after the ones from 'options' prop -->
                    <b-form-select-option v-for="(countryName,index) in countryNameArray" :key="index"  :value="countryName" >{{countryName}}</b-form-select-option>
                  
                  </b-form-select>
               
                 <!-- <b-form-select v-if="selectedCountry===4"  v-model="selected" class="mb-3" @change="ChangeDate" >-->
                  <!-- This slot appears above the options from 'options' prop -->
                 <!-- <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Date --</b-form-select-option>
                  </template>-->
                  <!-- These options will appear after the ones from 'options' prop -->
                 <!-- <b-form-select-option  v-for="i in dates" :key="i.extractWeek" :value="i.extractWeek" >{{i.extractWeek}}</b-form-select-option>
                  </b-form-select>-->
                  
              
          <div v-if="selectedCountry" class="rounded p-3" style="font: 14px/16px Arial, Helvetica, sans-serif; background: rgba(222, 222, 222, 0.9);">
            <div class="text-center">
              
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
            <div style="background-color:#1C8BC2;border-radius:10px;height:10px;width:10px;margin-right:5px;">
            </div>
              <strong v-if="selectedCountry==='Italy'">0 - (0 - 3)</strong>
              <strong v-if="selectedCountry==='France'">0 - (0)</strong>
              <strong v-if="selectedCountry==='Germany'">0 - (0)</strong>
              <strong v-if="selectedCountry==='Serbia'">0 - (0 - 18)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">0 - (0 - 30)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">0</strong>
            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#8EC4CD;border-radius:10px;height:10px;width:10px;margin-right:5px;"></div>
              <strong v-if="selectedCountry==='Italy'">1 - (4 - 9)</strong>
              <strong v-if="selectedCountry==='France'">1 - (1 - 3)</strong>
              <strong v-if="selectedCountry==='Germany'">1 - (1 - 4)</strong>
              <strong v-if="selectedCountry==='Serbia'">1 - (19 - 55)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">1 - (31 - 80)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">1</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
            <div style="background-color:#F7FFA7;border-radius:10px;height:10px;width:10px;margin-right:5px;">
            </div>
              <strong v-if="selectedCountry==='Italy'">2 - (10 - 18)</strong>
              <strong v-if="selectedCountry==='France'">2 - (4 - 7)</strong>
              <strong v-if="selectedCountry==='Germany'">2 - (5 - 7)</strong>
              <strong v-if="selectedCountry==='Serbia'">2 - (56 - 115)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">2 - (81 - 150)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">2</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#FDE97D;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">3 - (19 - 34)</strong>
              <strong v-if="selectedCountry==='France'">3 - (8 - 10)</strong>
              <strong v-if="selectedCountry==='Germany'">3 - (8 - 10)</strong>
              <strong v-if="selectedCountry==='Serbia'">3 - (116 - 197)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">3 - (151 - 250)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">3</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#FFD27D;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">4 - (35 - 58)</strong>
              <strong v-if="selectedCountry==='France'">4 - (11 - 15)</strong>
              <strong v-if="selectedCountry==='Germany'">4 - (11 - 15)</strong>
              <strong v-if="selectedCountry==='Serbia'">4 - (198 - 202)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">4 - (251 - 375)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">4</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#FFC262;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">5 - (59 - 100)</strong>
              <strong v-if="selectedCountry==='France'">5 - (16 - 22)</strong>
              <strong v-if="selectedCountry==='Germany'">5 - (16 - 22)</strong>
              <strong v-if="selectedCountry==='Serbia'">5 - (203 - 313)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">5 - (376 - 500)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">5</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#FBAE5F;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">6 - (101 - 167)</strong>
              <strong v-if="selectedCountry==='France'">6 - (23 - 29)</strong>
              <strong v-if="selectedCountry==='Germany'">6 - (23 - 36)</strong>
              <strong v-if="selectedCountry==='Serbia'">6 - (314 - 482)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">6 - (501 - 750)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">6</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#FB7C47;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">7 - (168 - 293)</strong>
              <strong v-if="selectedCountry==='France'">7 - (30 - 59)</strong>
              <strong v-if="selectedCountry==='Germany'">7 - (37 - 77)</strong>
              <strong v-if="selectedCountry==='Serbia'">7 - (483 - 731)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">7 - (751 - 1000)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">7</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#F94626;border-radius:10px;height:10px;width:10px;margin-right:5px;">
              </div>
              <strong v-if="selectedCountry==='Italy'">8 - (294 - 568)</strong>
              <strong v-if="selectedCountry==='France'">8 - (60 - 205)</strong>
              <strong v-if="selectedCountry==='Germany'">8 - (78 - 206)</strong>
              <strong v-if="selectedCountry==='Serbia'">8 - (732 - 1225)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">8 - (1001 - 1250)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">8</strong>

            </div>
            <br>
            <div style="display:flex;align-items:center;justify-content:center">
              <div style="background-color:#D40414; border-radius:10px;height:10px;width:10px;margin-right:5px;"></div>
              <strong v-if="selectedCountry==='Italy'">9 - (&gt; 568)</strong>
              <strong v-if="selectedCountry==='France'">9 - (&gt; 205)</strong>
              <strong v-if="selectedCountry==='Germany'">9 - (&gt; 206)</strong>
              <strong v-if="selectedCountry==='Serbia'">9 - (&gt; 1225)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='BAd'">9 - (&gt; 1250)</strong>
              <strong v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">9</strong>

              </div>
              
            <br>
            <div v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'">
                <b-button size="sm" id="tooltip-target-1" style="cursor:help" class="w-100">
                  <i class="fa-solid fa-circle-info"></i>
                </b-button>
                <b-tooltip target="tooltip-target-1" triggers="hover" placement="left" >
                  <div style="max-height:320px; overflow:auto; font-size:12px; line-height:1.2;width:300px;">
                    <!-- Πίνακας 3 -->
                    <h6 style="margin:6px 0;">Central Macedonia:</h6>
                    <table border="1" cellpadding="4" cellspacing="0" style="width:100%; border-collapse:collapse;">
                       <thead>
                        <tr>
                          <th>Category</th>
                          <th>Number of Mosquitoes</th>
                          <th>Risk Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>0</td><td>0 - 4</td><td rowspan="2" style="text-align:center;">low</td></tr>
                        <tr><td>1</td><td>5 - 10</td></tr>
                        <tr><td>2</td><td>11 - 22</td><td rowspan="3" style="text-align:center;">medium</td></tr>
                        <tr><td>3</td><td>23 - 40</td></tr>
                        <tr><td>4</td><td>41 - 67</td></tr>
                        <tr><td>5</td><td>68 - 117</td><td rowspan="5" style="text-align:center;">high</td></tr>
                        <tr><td>6</td><td>118 - 200</td></tr>
                        <tr><td>7</td><td>201 - 345</td></tr>
                        <tr><td>8</td><td>346 - 716</td></tr>
                        <tr><td>9</td><td>&gt; 716</td></tr>
                      </tbody>
                    </table>

                    <!-- Πίνακας 1 (variant A) -->
                    <h6 style="margin:10px 0 6px;">Crete:</h6>
                    <table border="1" cellpadding="4" cellspacing="0" style="width:100%; border-collapse:collapse;">
                      <thead>
                        <tr>
                          <th>Category</th>
                          <th>Number of Mosquitoes</th>
                          <th>Risk Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>0</td><td>0</td><td rowspan="4" style="text-align:center;">low</td></tr>
                        <tr><td>1</td><td>1</td></tr>
                        <tr><td>2</td><td>2</td></tr>
                        <tr><td>3</td><td>3</td></tr>
                        <tr><td>4</td><td>4 - 6</td><td rowspan="3" style="text-align:center;">medium</td></tr>
                        <tr><td>5</td><td>7 - 14</td></tr>
                        <tr><td>6</td><td>15 - 27</td></tr>
                        <tr><td>7</td><td>28 - 35</td><td rowspan="3" style="text-align:center;">high</td></tr>
                        <tr><td>8</td><td>36 - 50</td></tr>
                        <tr><td>9</td><td>&gt; 50</td></tr>
                      </tbody>
                    </table>

                    <!-- Πίνακας 1 (variant B) -->
                    <h6 style="margin:10px 0 6px;">Thessaly:</h6>
                    <table border="1" cellpadding="4" cellspacing="0" style="width:100%; border-collapse:collapse;">
                      <thead>
                        <tr>
                          <th>Category</th>
                          <th>Number of Mosquitoes</th>
                          <th>Risk Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>0</td><td>0</td><td rowspan="2" style="text-align:center;">low</td></tr>
                        <tr><td>1</td><td>1</td></tr>
                        <tr><td>2</td><td>2 - 5</td><td rowspan="6" style="text-align:center;">medium</td></tr>
                        <tr><td>3</td><td>6 - 8</td></tr>
                        <tr><td>4</td><td>9 - 17</td></tr>
                        <tr><td>5</td><td>18 - 28</td></tr>
                        <tr><td>6</td><td>29 - 43</td></tr>
                        <tr><td>7</td><td>44 - 72</td></tr>
                        <tr><td>8</td><td>73 - 150</td><td rowspan="2" style="text-align:center;">high</td></tr>
                        <tr><td>9</td><td>&gt; 150</td></tr>
                      </tbody>
                    </table>

                    <!-- Πίνακας 1 (variant C) -->
                    <h6 style="margin:10px 0 6px;">Western Greece:</h6>
                    <table border="1" cellpadding="4" cellspacing="0" style="width:100%; border-collapse:collapse;">
                      <thead>
                        <tr>
                          <th>Category</th>
                          <th>Number of Mosquitoes</th>
                          <th>Risk Category</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>0</td><td>0</td><td rowspan="2" style="text-align:center;">low</td></tr>
                        <tr><td>1</td><td>1</td></tr>
                        <tr><td>2</td><td>2 - 4</td><td rowspan="5" style="text-align:center;">medium</td></tr>
                        <tr><td>3</td><td>5 - 7</td></tr>
                        <tr><td>4</td><td>8 - 11</td></tr>
                        <tr><td>5</td><td>12 - 18</td></tr>
                        <tr><td>6</td><td>19 - 27</td></tr>
                        <tr><td>7</td><td>28 - 42</td><td rowspan="3" style="text-align:center;">high</td></tr>
                        <tr><td>8</td><td>43 - 77</td></tr>
                        <tr><td>9</td><td>&gt; 77</td></tr>
                      </tbody>
                    </table>
                  </div>
                </b-tooltip>

              </div>
          </div>
          </div>
          </div>
          
    </l-control>
    <l-control position="bottomright" style="width:400px">
                <div v-if="selectedCountry==='Greece'" class=" p-2 ml-auto info-text">
                  <b-form-select size="sm" v-model="selectedModel" class="" @change="ChangeModel" style="background-color:#00948a!important; color:#fff;">
                  <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select Model --</b-form-select-option>
                    </template>

                    <!-- These options will appear after the ones from 'options' prop -->
                    <b-form-select-option :value="'BAd'" >Model : BAd </b-form-select-option>
                    <b-form-select-option :value="'MAMOTH'" >Model : MAMOTH </b-form-select-option>
                  
                  </b-form-select>
               </div>
                
               <div v-if="selectedCountry==='Italy' || selectedCountry==='France' || selectedCountry==='Germany' || selectedCountry==='Serbia'" class=" p-2 info-text">
                <p  style= "text-align:justify;font-size:12px;"> Classes of mosquitoes’ abundance predictions at each trap, as produced by the MAMOTH generic data-driven model. The model uses satellite Earth Observation (environmental, meteorological, geomorphological), entomological and epidemiological data. </p>
               </div>
               <div v-if="selectedCountry==='Greece' && selectedModel==='BAd'"  class=" p-2 ml-auto info-text">
                 <p  style= "text-align:justify;font-size:12px;"> Classes of mosquitoes’ abundance predictions at settlement level, as produced by the BAd site-specific data-driven model. </p>
               </div>
               <div v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH'"  class=" p-2 ml-auto info-text">
                <p  style= "text-align:justify;font-size:12px;"> Classes of mosquitoes’ abundance predictions at each trap, as produced by the MAMOTH generic data-driven model. The model uses satellite Earth Observation (environmental, meteorological, geomorphological), entomological and epidemiological data. </p>  
                </div>
              

              
    </l-control>
        <div v-if="tst" class="loader"></div>
        <!--<div v-if="selectedCountry!=='Greece' && selectedCountry!=='Italy' && selectedCountry!=='France' && selectedCountry!=='Germany'">
        <l-circle-marker
                         v-for="i in Mosquitoes_Abundance_Data" :lat-lng="[i.y, i.x]"
                         :key="i.stationid"
                         :fillColor="colors_Classification(i.class_prediction/10)"
                         :radius="8"
                         :stroke="false"
                         :fillOpacity="1"
                         v-on:mousemove="pointData=i.class_prediction"
                         >
          
          <l-tooltip>{{pointData/10}}</l-tooltip>
        </l-circle-marker>
        </div>-->
        <div v-if="selectedCountry!=='Greece'">
          <div v-for="(i,index) in Mosquitoes_Abundance_Data" :key="index+'Mosquitoes_Abundance_Data'">
            <div v-if="selectedYear<2023" >
              <l-circle-marker
                              :lat-lng="[i.y, i.x]"
                              :fillColor="colors_Classification(i.class_prediction)"
                              :radius="8"
                              :stroke="false"
                              :fillOpacity="1"
                              v-on:mousemove="pointData=i.class_prediction"
                              >
                
                <l-tooltip>{{pointData}}</l-tooltip>
              </l-circle-marker>
            </div>
            <div v-if="selectedYear>2022" >
                <l-rectangle :bounds="i.bounds"
                :fillColor=colors_Classification(i.class_prediction)
                :color=colors_Classification(i.class_prediction)
                :weight=1 
                >
                  <l-tooltip class="text-center">{{i.class_prediction}} </l-tooltip>
                  <l-popup  style="font-size:11px; text-align: center;" >{{i.class_prediction}}</l-popup>
                </l-rectangle>
            </div>
          </div>
        </div>
        <div v-if="selectedCountry==='Greece' && badweek_data && selectedModel==='BAd'">
        <l-circle-marker
                        v-for="(i,index,num) in badweek_data" :lat-lng="[i.y, i.x]"
                        v-if="i['badweek'+value]!==null"
                        :key="num"
                        :fillColor="colors_Classification(i['badweek'+value])"
                        :color="colors_Classification(i['badweek'+value])"
                        :fillOpacity="1"
                        :radius="5"
                        :weight="1"
                        @click="openChart(i)"
                        v-on:mousemove="settlementActive(i)"> 

          <l-popup  style="font-size:11px; text-align: center;" >{{nameOfSettlement}}</l-popup>
          <l-tooltip class="text-center">{{nameOfSettlementTooltip}}:<br/> {{i['badweek'+value]}} </l-tooltip>
        </l-circle-marker>
        </div>
        <div v-if="selectedCountry==='Greece' && selectedModel==='MAMOTH' && mamoth_data">
            <div v-for="(i,index) in mamoth_data" :key="index+'mamoth_data'">
              <div v-if="selectedYear>2022" >
              <l-rectangle :bounds="i.bounds" @click="openChart(i)" 
              :fillColor=colors_Classification(i.predictions)
              :color=colors_Classification(i.predictions)
              :weight=1 
              >
                <l-tooltip class="text-center"> {{i.station_id}} : {{i.predictions}} </l-tooltip>
                <l-popup  style="font-size:11px; text-align: center;" >{{i.station_id}} : {{i.predictions}}</l-popup>
              </l-rectangle>
              </div>
              <div v-else >
                <l-circle-marker :lat-lng="[i.y, i.x]"
                            :fillColor="colors_Classification(i.predictions)"
                            :color="colors_Classification(i.predictions)"
                            :fillOpacity="1"
                            :radius="5"
                            :weight="1"
                            @click="openChart(i)"
                            >

                
                <l-tooltip class="text-center"> {{i.station_id}} : {{i.predictions}} </l-tooltip>
                <l-popup  style="font-size:11px; text-align: center;" >{{i.station_id}} : {{i.predictions}}</l-popup>

              </l-circle-marker> 
            </div>
            </div>
        </div>
        <l-polygon ref="polygon_country"
                v-for="(countryData,index) in polygon.latlngs" 
               
                :key="index+'country'" 
                :lat-lngs="countryData"
                :fillColor="countryColorArray[index]"
                :color="countryColorArray[index]"
                :fillOpacity="0.1"
                @click="focusOnCountry(index)"
              />
      </l-map>

      </div>
    </div>
  </div>
 
  </div>
  
  <div v-if="selectedCountry" class="px-2" >
  <div class="border border-dark ">
   <div  class="" style="width:100%; background-color:#FFFFFF; height: 130px;" >
    <div class="d-flex justify-content-between px-3">
      <div class="px-3 py-1">
      <p style="background-color:#d6d8db;" class="rounded p-2">Week:</p>
      </div>
      <b-form-select  v-model="selectedYear" class="mt-2" style="width:11%; background-color: #00948a; color:#fff" @change="ChangeYear">
                <!-- This slot appears above the options from 'options' prop -->
                  <template #first>
                    <b-form-select-option :value="null" disabled>-- Select Year --</b-form-select-option>
                  </template>

                  <!-- These options will appear after the ones from 'options' prop -->

                  <b-form-select-option v-for="year in years" :key="year.extractYear" :value="year.extractYear" >{{year.extractYear}}</b-form-select-option>
      </b-form-select>
    </div>
        <vue-slider class="px-4"  style="z-index:1005; " 
        ref="slider" 
        v-model="value"
        :marks="true"
        :data="data"
        @change="ChangeWeek">
        <template v-slot:step="{ active }">
        <div :class="['custom-step', { active }]"></div>
      </template>
        </vue-slider>
     
  </div>
  </div>
  </div>
  <b-modal id="modal-center" v-model="modalError" centered title="Error" hide-footer>
      <p class="my-4">No Data Available</p>
    </b-modal>
</div>
</template>

<script>
import {LMap, LTileLayer, LCircle,LCircleMarker, LPolygon,LControl, LMarker,LPopup,LTooltip,LRectangle} from 'vue2-leaflet';
import axios from '../axios-auth'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import VueHighcharts from 'vue2-highcharts'
import {MyFunctions} from "../components/colorClassificationsMAb";
import routes from '../routes/routes'
//import routes from '../routes/routes.js'
export default {
  components: {
    VueHighcharts,
    LPopup,
    VueSlider,
    LMap,
    LTileLayer,
    LCircle,
    LCircleMarker,
    LPolygon,
    LControl,
    LMarker,
    LTooltip,
    LRectangle
  },
  data(){
    return{
      mamoth_data:null,
      selectedModel:'BAd',
      modalError:false,
      badweek_data:null,
      selected_country_old:null,
      countryNameArray:[],
      countryColorArray:['#3388ff','#3388ff','#3388ff','#3388ff','#3388ff'],
      polygon: {
        latlngs: [],
      },
      pointData:null,
      display: 'none',
      nameOfSettlement:'',
      nameOfSettlementTooltip:'',
      charts:false,
      col: 'col-md-12',
      selectedYear:'2020',
      year:'',
      errorMsg:'',
      tst:true,
      Mosquitoes_Abundance_Data:'',
      dates:'',
      years:'',
      selected:null,
      selectedCountry:null,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      center: [43.6659, 17.1937],
      colors:['#1C8BC2','#8EC4CD','#F7FFA7','#FDE97D','#FFD27D','#FFC262','#FBAE5F','#FB7C47','#F94626','#D40414'],

      value: null,
      data:[],
        
        
      
      optionsChartBar:{
        chart: {
          type: 'column'

        },
        title: {
          text: ''
        },
        yAxis: {
          title: {text:'',},
          tickAmount: 10
        },
        xAxis: {
          title: {text:'week',},
          tickAmount: 10
        },
        
        plotOptions: {
                series: {
                shadow: true,
                borderWidth: 0,
                minPointLength: 5,
                }
          },
        credits: {
          enabled: false
        },
        series: [],
      },
      countryArray:['France','Germany','Greece','Italy','Serbia'],
    
    }

    
  },
  async created() {
    var user =JSON.parse(localStorage.getItem('user'))
    this.group = user.groups
    var country_geom=null
    
    country_geom=await axios.get('entomologicalData/country/',{params:{group:JSON.stringify(this.group)}})////.catch(error=> routes.replace('/'))
    

    this.country=country_geom.data
    //console.log(this.country)

    for(var i=0; i<country_geom.data.length; i++) {
      if(this.countryArray.includes(this.country[i].name)){

      
      this.countryNameArray.push(this.country[i].name)
      //console.log(this.countryNameArray)

      const latlgn = L.geoJSON(JSON.parse(this.country[i].json))
      const latlgn_id = latlgn._leaflet_id - 1
      // console.log(latlgn)
      const latlgn_data = latlgn._layers[latlgn_id]._latlngs

      this.polygon.latlngs[i] = latlgn_data
      }
    }
    console.log(this.polygon.latlngs.length)

    if(this.polygon.latlngs.length===0){
      this.modalError=true
    }
    /*const years_all=await axios.get('mosquitoes-abundance/human-cases-years/',{headers: { Authorization: `Bearer ${token}` }})
    this.years=years_all.data
    this.selectedYear=this.years[0].extractYear
    await this.Weeks()
    //console.log(this.dates)
    this.value=this.dates[0].extractWeek
    
    this.MosquitoesAbundanceData()
    */
    /*const Mosquitoes_Abundance_all = await axios.get('mosquitoes-abundance/',{
      headers: { Authorization: `Bearer ${token}` },
      params: {week: this.dates[0].extractWeek, year: this.years[0].extractYear}
    })

    this.Mosquitoes_Abundance_Data = Mosquitoes_Abundance_all.data
    */
    
    //console.log(this.Mosquitoes_Abundance_Data)
    //this.selected=this.dates[0].extractWeek
    //const token = localStorage.getItem('token')
    //const badweek_all=await axios.get('mosquitoes-abundance/weekly_Gr/',{
    //  headers: { Authorization: `Bearer ${token}` },
    //  params: {year: this.selectedYear}
     // })
  //  this.badweek_data=badweek_all.data
    //console.log('badWeek_data',this.badweek_data)

    this.tst=false

  },
  methods: {
    getMAMOTHdata(){
        const token = localStorage.getItem('token')
        var v=this

        axios.get('mamoth/data/years/',{
            headers: { Authorization: `Bearer ${token}` },
        }).then((response)=>{
            console.log(response)
            v.years=response.data
            v.selectedYear=v.years[0].extractYear
            //v.sliderDataGreece()
            axios.get('mamoth/data/weeks/',{
            headers: { Authorization: `Bearer ${token}` },
            params:{year:v.years[0].extractYear}
        }).then((response)=>{
            console.log('weeks',response.data)
            var mamothweek_data=response.data
            this.data=[]
        
            for(var i=0; i<mamothweek_data.length; i++){  
              this.data.push(mamothweek_data[i].extractWeek)
            }
            this.value=this.data[0]
            v.getAllMAMOTHdata()
            //v.sliderDataGreece()
        })
        })
      
        
    },
    getBoundingBox(center) {
      const distance = 1; // distance in kilometers
      const R = 6371; // radius of the earth in kilometers
      const dLat = distance / R;
      const dLon = distance / (R * Math.cos(Math.PI / 180 * center[0]));
      const minLat = center[0] - dLat * 180 / Math.PI;
      const maxLat = center[0] + dLat * 180 / Math.PI;
      const minLon = center[1] - dLon * 180 / Math.PI;
      const maxLon = center[1] + dLon * 180 / Math.PI;
      return [[minLat, minLon],[maxLat, maxLon]];
    },
    getAllMAMOTHdata(){
        const token = localStorage.getItem('token')
        var v=this
        
        this.tst=true

        axios.get('mamoth/data/',{
            headers: { Authorization: `Bearer ${token}` },
            params:{year:v.selectedYear,week:v.value}
        }).then((response)=>{
            v.mamoth_data=response.data
            for(var yy=0; yy<v.mamoth_data.length; yy++){
              v.mamoth_data[yy].bounds= this.getBoundingBox([v.mamoth_data[yy].y,v.mamoth_data[yy].x]);
            }
            console.log(v.mamoth_data)
            this.tst=false

            //const center = [38.2982224827635, 23.494262695312504]; // example center point
            //this.bounds = this.getBoundingBox(center);
            //console.log(this.bounds)
        })
    },
    ChangeModel(){
      if(this.selectedModel==='MAMOTH'){
        this.getMAMOTHdata()
      }else{
        this.ChangeCountry()
      }
    },
    async MosquitoesAbundanceData(){
      const token = localStorage.getItem('token')
      const Mosquitoes_Abundance_all = await axios.get('mosquitoes-abundance/',{
        headers: { Authorization: `Bearer ${token}` },
        params: {week: this.value, year: this.selectedYear, country: this.selectedCountry,type:'Culex'}
      })////.catch(error=> routes.replace('/'))
      this.Mosquitoes_Abundance_Data = Mosquitoes_Abundance_all.data
      if(this.selectedYear>2022){
        for(var yy=0; yy<this.Mosquitoes_Abundance_Data.length; yy++){
          this.Mosquitoes_Abundance_Data[yy].bounds= this.getBoundingBox([this.Mosquitoes_Abundance_Data[yy].y,this.Mosquitoes_Abundance_Data[yy].x]);
        }
      }
     
    },
    async MosquitoesAbundanceDataGreece(){
      this.tst=true
      const token = localStorage.getItem('token')
        const badweek_all=await axios.get('mosquitoes-abundance/weekly_Gr/',{
        headers: { Authorization: `Bearer ${token}` },
        params: {year: this.selectedYear}
        })////.catch(error=> routes.replace('/'))
        this.badweek_data=badweek_all.data
        console.log(this.badweek_data)
      /*if(this.selectedYear===2020){
        this.value= 16
        this.data=[16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39]
        }else{
          this.value= 22
          this.data=[22,23]
        }*/
       if(this.badweek_data.length>0){
        this.sliderDataGreece()
       }
        this.tst=false
    },
    sliderDataGreece(){
      this.data=[]
      var keys=Object.keys(this.badweek_data[0])
        for(var i=1; i<53; i++){
         // console.log(this.badweek_data[0])
          if(keys.includes('badweek'+i)){
            this.data.push(i)
            //console.log(i)
          }
        }
      this.value= this.data[0]
     // console.log(this.data)
    },
    async Weeks(){
      const token = localStorage.getItem('token')
      const dates_all=await axios.get('mosquitoes-abundance/human-cases-dates/',{
      headers: { Authorization: `Bearer ${token}` },
      params: {year: this.selectedYear, country: this.selectedCountry,type:'Culex'}
      })////.catch(error=> routes.replace('/'))

    this.dates=dates_all.data
    //console.log(this.dates)
    },
    
    async ChangeCountry(){
      this.close()
      var num=this.countryNameArray.indexOf(this.selectedCountry)
      this.countryColorArray[num]='#EC008C'
      
      if(this.selected_country_old!==null){
      
        this.countryColorArray[this.selected_country_old]='#3388ff'
      }
    
    this.selected_country_old=num

     // console.log(this.$refs.slider)
     if(this.selectedCountry === 'Greece'){
        this.tst=true
        this.years=[{extractYear:2025},{extractYear:2024},{extractYear:2023},{extractYear:2022},{extractYear:2021}]
        this.selectedYear=this.years[0].extractYear
        const token = localStorage.getItem('token')
        const badweek_all=await axios.get('mosquitoes-abundance/weekly_Gr/',{
        headers: { Authorization: `Bearer ${token}` },
        params: {year: this.selectedYear}
        })////.catch(error=> routes.replace('/'))
        this.badweek_data=badweek_all.data
        //console.log(this.badweek_data[0])
        if(this.badweek_data.length>0){
          this.sliderDataGreece()
        }
        //this.sliderDataGreece()
        this.$refs.myMap.mapObject.fitBounds([[40.7634502432201, 23.9569594997323], [35.8924119881264, 23.8465820717025]])
        //var number = this.badweek_data..match(/(\d+)/);
        
        //this.data=[22,23]
        this.selectedModel='BAd'
        this.tst=false
     }
     else{
        this.tst=true
        if(this.selectedCountry==='Italy'){
          this.$refs.myMap.mapObject.fitBounds([[46.2634502432201,13.0569594997323],[43.6924119881264,12.1465820717025]])
        }else if(this.selectedCountry==='France'){
          this.$refs.myMap.mapObject.fitBounds([[48.864716,2.349014],[40.864716,6.349014]])

        }else if(this.selectedCountry==='Germany'){
          this.$refs.myMap.mapObject.fitBounds([[52.520008,15.404954],[46.520008,8.404954]])

        }else if(this.selectedCountry==='Serbia'){
          this.$refs.myMap.mapObject.fitBounds([[47.787197,23.8569594997323],[41.087197,18.6465820717025]])

        }
        const token = localStorage.getItem('token')
        const years_all=await axios.get('mosquitoes-abundance/human-cases-years/',{
          headers: { Authorization: `Bearer ${token}` },
          params: { country: this.selectedCountry, type:'Culex'}
          })////.catch(error=> routes.replace('/'))
          //console.log(years_all.data)
        this.years=years_all.data
        //console.log(this.years)
        this.selectedYear=this.years[0].extractYear
        await this.Weeks()
        //console.log(this.dates)
        this.value=this.dates[0].extractWeek
        
        this.MosquitoesAbundanceData()
        this.selected=this.dates[0].extractWeek
        this.tst=false
        this.data=[]
        
        for(var i=0; i<this.dates.length; i++){  
          this.data.push(this.dates[i].extractWeek)
        }
         
        //this.year=res[0]
      
        this.value=this.data[0]
      //  console.log(this.data)
        
      }
     
    },

    colors_Classification(data){
      if(this.selectedCountry==='Greece'){
        if(this.selectedYear===2020){
        return MyFunctions.colors_Gr(data)
        }else{
          return this.colors[data]
        }
      }
      else {
        return this.colors[data]
      }
      /* if(this.selectedCountry==='Italy'){
        return MyFunctions.colors_It_culex(data)
      }
      else if(this.selectedCountry==='France'){
        return MyFunctions.colors_Fr_culex(data)
      }
      else if(this.selectedCountry==='Germany'){
        return MyFunctions.colors_Ge_culex(data)
      }
      else if(this.selectedCountry==='Serbia'){
        return MyFunctions.colors_Se_culex(data)
      }*/
    },
    callbackRange (val) {
      this.rangeValue = val
    },
    ChangeWeek(){
     // console.log(this.value)
      if(this.selectedCountry!=='Greece' && this.value!=='0'){
        this.MosquitoesAbundanceData()
      }
      if(this.selectedCountry==='Greece' && this.selectedModel==='MAMOTH'){
        this.getAllMAMOTHdata()
      }
      if(this.value==='0'){
        this.Mosquitoes_Abundance_Data=null
      }
      
    },

    openChart(i){
      console.log(i)
      this.display='block'
      this.col='col-md-7'
      this.charts=true
      if(this.selectedModel==='BAd'){

        
            this.nameOfSettlement=i.settlement
          
           
            //this.$refs.myMap.mapObject.invalidateSize();
            var lineChartsBar = this.$refs.lineChartsBar
            
            if (lineChartsBar) {
            lineChartsBar.removeSeries()
            }
            var col=[]
            for(var j=16; j<51; j++){
              var colortest= this.colors_Classification(i['badweek'+j])
              if(this.data.includes(j)){
                col.push({y: i['badweek'+j], color:colortest})
              }
            
            }
        
          lineChartsBar.getChart().xAxis[0].setCategories(this.data)
          lineChartsBar.addSeries({
              name: "Class",
              data: col,
              
              })
          
          lineChartsBar.getChart().setTitle({text:i.settlement})
      }else{
        var lineChartsBar = this.$refs.lineChartsBar
        
        if (lineChartsBar) {
         lineChartsBar.removeSeries()
        }
        console.log(i)
        var v=this
        const token = localStorage.getItem('token')
        axios.get('mamoth/data/chart/',{
            headers: { Authorization: `Bearer ${token}` },
            params:{year:v.selectedYear,station_id:i.station_id}
        }).then((response)=>{
            console.log('chart',response.data)
            var chartData=response.data[0]
            var col=[]
       
            for(var jj=0; jj<chartData.array_predictions.length; jj++){
              var colortest= this.colors_Classification(chartData.array_predictions[jj])
              
              col.push({y: chartData.array_predictions[jj], color:colortest})
          
          
            }
            lineChartsBar.getChart().xAxis[0].setCategories(chartData.array_weeks)
            lineChartsBar.addSeries({
                name: "Week",
                data: col,
                
                })
        })
        lineChartsBar.getChart().setTitle({text:i.station_id})
      }
    
    },
    settlementActive(i){
      this.nameOfSettlementTooltip=i.settlement
    },
    async ChangeYear(){
      if(this.selectedCountry!='Greece'){
      await this.Weeks()
      this.data=[]
      //this.data.push('0')
        
        for(var i=0; i<this.dates.length; i++){  
          this.data.push(this.dates[i].extractWeek)
        }
        
        this.value=this.data[0]
        this.MosquitoesAbundanceData()
      }else{
          if(this.selectedModel==='BAd'){
            this.MosquitoesAbundanceDataGreece()
          }else{
            const token = localStorage.getItem('token')
            var v=this
            axios.get('mamoth/data/weeks/',{
            headers: { Authorization: `Bearer ${token}` },
            params:{year:v.selectedYear}
            }).then((response)=>{
                console.log('weeks',response.data)
                var mamothweek_data=response.data
                this.data=[]
            
                for(var i=0; i<mamothweek_data.length; i++){  
                  this.data.push(mamothweek_data[i].extractWeek)
                }
                this.value=this.data[0]
                v.getAllMAMOTHdata()
                //v.sliderDataGreece()
            })
          }
          
      }
        
    },
    focusOnCountry(index){
      
      
      //console.log(this.countryNameArray[index])
      if(this.countryNameArray[index]!==this.selectedCountry){
      this.selectedCountry=this.countryNameArray[index]
      this.ChangeCountry()
      }
    },
    close(){
      this.display='none'
     
      this.col='col-md-12'
      
    },
  }
}
</script>

<style>
.custom-step {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    box-shadow: 0 0 0 3px #ccc;
    background-color: #fff;
  }
  .custom-step.active {
    box-shadow: 0 0 0 3px #3498db;
    background-color: #3498db;
  }
  .leaflet-popup-content {
    width: 80px;
    
  }
  .vue-slider-dot-handle {

    background-color: #00948a!important ;
    }
  .vue-slider-process {
    background-color: #00948a!important;
}
.custom-step.active {
    box-shadow: 0 0 0 3px #00948a!important;
    background-color: #00948a!important;
}
.vue-slider-dot-tooltip-inner {
    border-color: #00948a!important;
    background-color: #00948a!important;
}

.tooltip{
  width:320px;
  background-color:#000;
  border-radius:8px;
}
</style>
